import React, { useState, useRef } from 'react';
import {
    CCard, CCardBody, CButton, CCardHeader, CSpinner, CAccordion,
    CAccordionItem,
    CAccordionHeader,
    CAccordionBody
} from '@coreui/react';
import * as XLSX from 'xlsx';
import { v4 as uuidv4 } from 'uuid';
import { useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { ProjectRepository, projectDetailsFromResponse } from 'src/repositories/projectRepository';
import { UserRepository } from 'src/repositories/userRepository';
import CIcon from '@coreui/icons-react'
import { cilSave } from '@coreui/icons';
import _ from 'lodash';
import { max_questions, max_users } from './exportData';
import {
    DEFAULT_VOICE_AI_MODEL,
    languagesStateFromProjectDetails,
    normalizeVoiceModelId,
} from './aiVoiceModels';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import toastManager from 'src/helpers/toastManager';
import { Step1 } from './Step1';
import { Step3 } from './Step3';
import { Step1Static } from './Step1Static';
import { useNavigate } from 'react-router-dom';
import messages from '../../assets/images/messages-1-svgrepo-com.svg';
import questionsIcon from '../../assets/images/question.png';
import languageIcon from '../../assets/images/language-svgrepo-com.svg'
var cleanedProjectId;
// WizardComponent with state lifted up
const WizardComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { projectId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [desc, setDesc] = useState([]);
    const [initialDesc, setinitialDesc] = useState([]);
    const [name, setName] = useState([]);
    const [status, setStatus] = useState([]);
    const [startMessage, setStartMessage] = useState('');
    const [endMessage, setEndMessage] = useState('');
    const [qrCodeText, setQrCodeText] = useState('');
    const [qrCodeError, setQrCodeError] = useState('');
    const [initialStartMessage, setInitialStartMessage] = useState('');
    const [initialEndMessage, setInitialEndMessage] = useState('');
    const [step, setStep] = useState(0);
    const [questions, setQuestions] = useState([]);
    const [initialQuestionsData, setInitialQuestionsData] = useState([]);
    const [initialContactsData, setInitialContactsData] = useState([]); // Add a new state for contacts [Step 2
    const [contacts, setContacts] = useState([]); // Add a new state for contacts
    const [file, setFile] = useState(null);
    const [contactsFile, setContactsFile] = useState(null); // Add a new state for the file [Step 2
    const [error, setError] = useState(null);
    const [changesPresent, setchangesPresent] = useState(false);
    const [isEditingDesc, setIsEditingDesc] = useState(false);
    const [editableDesc, setEditableDesc] = useState(desc);
    const [selectedLanguages, setSelectedLanguages] = useState([
        { value: 'english', label: 'English', model: DEFAULT_VOICE_AI_MODEL },
    ]);
    const [initialLanguages, setInitialLanguages] = useState([
        { value: 'english', label: 'English', model: DEFAULT_VOICE_AI_MODEL },
    ]);
    const [userFiles, setuserFiles] = useState([]);
    const spanRef = useRef();
    const textAreaRef = useRef();
    const [isPageLoading, setIsPageLoading] = useState(true);
    const [initialQrCodeText, setInitialQrCodeText] = useState('');
    const [isReDeploy, setIsReDeploy] = useState(false);

    const isEditable = status === 'draft' || (status === 'failed' && isReDeploy);
    const messagesEditable = status === 'draft';
    useEffect(() => {
        const cleanId = cleanProjectId(projectId);
        cleanedProjectId = cleanId;
        const fetchData = async () => {
            try {
                const res = await ProjectRepository.getProjectDetailsById(cleanedProjectId);
                // const contactsRes = await UserRepository.getUserDetails(cleanedProjectId);
                const contactsRes = '';
                const data = projectDetailsFromResponse(res);
                if (data) {
                    setIsPageLoading(false);
                    var contactsData;
                    if (contactsRes && contactsRes.data) {
                        contactsData = contactsRes.data.map(contact => ({
                            ...contact,
                            phone_no: parseInt(contact.phone_no, 10), // Convert the phone_no property to an integer
                            isFieldOfficer: contact.is_field_officer ? "yes" : "no"
                        }));
                    }
                    if (data.status) {
                        if (data.status === 'DRAFT') {
                            setStatus('draft');
                        } else if (data.status === 'UNDEPLOYED') {
                            setStatus('undeployed');
                        } else if (data.status === 'FAILED' && data.failure_reason?.startsWith('OPTION_CHAR_LIMIT')) {
                            setStatus('failed');
                            setIsReDeploy(true);
                        } else {
                            navigate('/projects');
                        }
                    }
                    if (contactsData) {
                        setContacts(contactsData); // Set the contacts state with converted phone numbers
                        setInitialContactsData(contactsData);
                    }
                    if (data.questions) {
                        setQuestions(data.questions); // Set the questions state
                        setInitialQuestionsData(data.questions); // Set the initial questions data
                    }
                    if (data.name) {
                        setName(data.name);
                    }
                    if (data.description) {
                        setDesc(data.description);
                        setinitialDesc(data.description);
                    }
                    if (data.languages != null) {
                        const langs = languagesStateFromProjectDetails(data);
                        if (langs.length > 0) {
                            setSelectedLanguages(langs);
                            setInitialLanguages(langs);
                        }
                    }
                    if (data.template_messages) {
                        const firstMessage = data.template_messages.find(msg => msg.message_type === 'first');
                        const lastMessage = data.template_messages.find(msg => msg.message_type === 'last');

                        if (firstMessage) {
                            setStartMessage(firstMessage.message_text);
                            setInitialStartMessage(firstMessage.message_text);
                        }

                        if (lastMessage) {
                            setEndMessage(lastMessage.message_text);
                            setInitialEndMessage(lastMessage.message_text);
                        }
                    }
                    if (data.qr_code_text) {
                        setQrCodeText(data.qr_code_text);
                        setInitialQrCodeText(data.qr_code_text);
                    }
                    // set your state based on the fetched data
                }
            } catch (error) {
                console.error('Failed to fetch project details:', error);
                // notify('Failed to fetch project details');
            }
        };

        if (cleanedProjectId) {
            fetchData();
        } else {
            navigate('/projects');
        }
        setIsLoading(false);
    }, [projectId]);

    // const calculateTextWidth = () => {
    //     return `${spanRef.current.offsetWidth + 10}px`; // +10 for some padding
    // };

    // useEffect(() => {
    //     if (spanRef.current) {
    //         inputRef.current.style.width = calculateTextWidth();
    //     }
    // }, [desc]);

    const calculateTextWidth = () => {
        const textWidth = spanRef.current.offsetWidth + 10; // Calculate text width with padding
        return `${textWidth}px`; // Use the smaller value between calculated text width and max width
    };

    useEffect(() => {
        if (spanRef.current && textAreaRef.current) {
            // textAreaRef.current.style.width = calculateTextWidth(); // Set width
            // Adjust height dynamically based on the scrollHeight of the textarea
            textAreaRef.current.style.height = 'auto';
            textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
        }
    }, [desc]);

    const cleanProjectId = (id) => {
        if (!id.includes('&')) {
            return id;
        }
        const parts = id.split('&');
        return parts[0]; // Return only the part before the first '&'
    };

    const nextStep = () => setStep(step + 1);
    const prevStep = () => setStep(step - 1);
    const notify = (message) => toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
    const notifyInfo = (message) => toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });

    const stepChanges = async (prevStep, stepnum) => {
        if (prevStep === 0) {
            if (startMessage === '' || endMessage === '' || qrCodeText === '' && status === 'draft') {
                notify('greeting messages and qr code text cannot be empty please make sure you fill it!!');
                return;
            }
            if (startMessage !== initialStartMessage || endMessage !== initialEndMessage || qrCodeText.trim() !== initialQrCodeText) {
                try {
                    const templateMessages = [];
                    if (startMessage !== initialStartMessage || endMessage !== initialEndMessage) {
                        if (startMessage !== initialStartMessage) {
                            templateMessages.push({ message_type: 'first', message_text: startMessage });
                        } else {
                            templateMessages.push({ message_type: 'first', message_text: initialStartMessage });
                        }

                        if (endMessage !== initialEndMessage) {
                            templateMessages.push({ message_type: 'last', message_text: endMessage });
                        } else {
                            templateMessages.push({ message_type: 'last', message_text: initialEndMessage });
                        }
                    }
                    const normalizeQrCodeText = (text) => {
                        const trimmed = text.trim();
                        return trimmed;
                    };
                    await ProjectRepository.updateProject({ template_messages: templateMessages, qr_code_text: normalizeQrCodeText(qrCodeText) }, cleanedProjectId);
                    setInitialStartMessage(startMessage);
                    setInitialEndMessage(endMessage);
                    setInitialQrCodeText(normalizeQrCodeText(qrCodeText));
                    setQrCodeText(normalizeQrCodeText(qrCodeText));
                    setQrCodeError('');
                    notifyInfo('Template messages and QR code text updated');
                    setStep(stepnum);
                } catch (error) {
                    console.log("Template update error:", error.message);

                    // Check for QR code uniqueness error first
                    const errorString = String(error.message || error).toLowerCase();
                    const isQrCodeError =
                        error.message === 'qr_code_text must be unique' ||
                        errorString.includes('qr_code_text') ||
                        errorString.includes('qr code') ||
                        (errorString.includes('unique') && errorString.includes('qr'));

                    if (isQrCodeError) {
                        // Use forceError to always show QR code validation message
                        toastManager.forceError('qr_code must be unique');
                    } else {
                        // Check if it's a server error
                        if (errorString.includes('5xx') || errorString.includes('server error') || errorString.includes('internal')) {
                            notify('Server error occurred. Please try again later or contact support.');
                        } else {
                            notify('Failed to update template messages');
                        }
                    }
                    return; // Stop the step transition on error
                }
            } else {
                setStep(stepnum);
            }

        } else if (prevStep === 1) {
            // Step 2 (previously Step 1): Save questions if they have changed
            if (questions?.length == 0 && status === 'draft') {
                notify('Please make sure questions are added before proceeding!!');
                return;
            }
            if (JSON.stringify(questions) !== JSON.stringify(initialQuestionsData)) {
                try {
                    const questionsData = questions.map(question => ({
                        q_id: question.q_id,
                        q_text: question.q_text,
                        q_type: question.q_type,
                        options: question.options,
                        sequence_no: questions.indexOf(question) + 1
                    }));
                    await ProjectRepository.updateProject({ questions: questionsData }, cleanedProjectId);
                    setInitialQuestionsData(questions);
                    setStep(stepnum);
                } catch (error) {
                    console.error('Failed to update project:', error);
                    notify('Failed to update project');
                    return; // Stop the step transition on error
                }
            } else {
                setStep(stepnum);
            }
        } else if (prevStep === 2) {
            // Step 3 (previously Step 2): Save contacts if they have changed
            if (JSON.stringify(contacts) !== JSON.stringify(initialContactsData)) {
                try {
                    const usersData = contacts.map(contact => ({
                        phone_no: String(contact.phone_no),
                        name: contact.name,
                        is_field_officer: contact.isFieldOfficer === "yes" ? true : false
                    }));
                    await UserRepository.createUsers({ user: usersData }, cleanedProjectId);
                    setInitialContactsData(contacts);
                    setContacts(contacts);
                    setuserFiles([]);
                    setStep(stepnum);
                } catch (error) {
                    console.error('Failed to create user:', error);
                    notify('Failed to create user');
                    return; // Stop the step transition on error
                }
            } else {
                setStep(stepnum);
            }
        } else if (prevStep === 3) {
            setStep(stepnum);
            // Step 4 (previously Step 3): Save languages if they have changed
            // if (JSON.stringify(selectedLanguages) !== JSON.stringify(initialLanguages)) {
            //     try {
            //         const languageValues = selectedLanguages.map(language => language.value);
            //         await ProjectRepository.updateProject({ languages: languageValues }, cleanedProjectId);
            //         setInitialLanguages(selectedLanguages);
            //         setStep(stepnum);
            //     } catch (error) {
            //         console.error('Failed to update project:', error);
            //         notify('Failed to update project');
            //         return; // Stop the step transition on error
            //     }
            // } else {
            //     setStep(stepnum);
            // }
        }
    };



    const checkForChanges = () => {
        if (JSON.stringify(questions) !== JSON.stringify(initialQuestionsData) || JSON.stringify(contacts) !== JSON.stringify(initialContactsData) || JSON.stringify(selectedLanguages) !== JSON.stringify(initialLanguages)) {
            setchangesPresent(true);
        } else {
            setchangesPresent(false);
        }
    }
    const saveChangesNavigate = async () => {
        if (JSON.stringify(questions) !== JSON.stringify(initialQuestionsData)) {
            try {
                const questionsData = questions.map(question => ({
                    q_id: question.q_id,
                    q_text: question.q_text,
                    q_type: question.q_type,
                    options: question.options,
                    sequence_no: questions.indexOf(question) + 1
                }));
                await ProjectRepository.updateProject({ questions: questionsData }, cleanedProjectId);
                setInitialQuestionsData(questions);
            } catch (error) {
                console.error('Failed to update project:', error);
                notify('Failed to update project');
            }
        }

        if (JSON.stringify(contacts) !== JSON.stringify(initialContactsData)) {
            try {
                const usersData = contacts.map(contact => ({
                    phone_no: String(contact.phone_no),
                    name: contact.name,
                }));
                await UserRepository.createUsers({ user: usersData }, cleanedProjectId);
                setInitialContactsData(contacts);
            } catch (error) {
                console.error('Failed to create user:', error);
                notify('Failed to create user');
            }
        }

        if (JSON.stringify(selectedLanguages) !== JSON.stringify(initialLanguages)) {
            try {
                // API expects every `{ lang, model }` to include `model`; omitting it returns 400.
                const languages = selectedLanguages.map((l) => ({
                    lang: l.value,
                    model: normalizeVoiceModelId(l.model || DEFAULT_VOICE_AI_MODEL),
                }));
                await ProjectRepository.updateProject({ languages }, cleanedProjectId);
                setInitialLanguages(selectedLanguages);
            } catch (error) {
                console.error('Failed to update project:', error);
                notify('Failed to update project');
            }
        }
        if (startMessage !== initialStartMessage || endMessage !== initialEndMessage) {
            try {
                const templateMessages = [];
                templateMessages.push({ message_type: 'first', message_text: startMessage });
                templateMessages.push({ message_type: 'last', message_text: endMessage });
                await ProjectRepository.updateProject({ template_messages: templateMessages }, cleanedProjectId);
                setInitialStartMessage(startMessage);
                setInitialEndMessage(endMessage);
            } catch (error) {
                console.log("Project update error:", error.message);
                const errorString = String(error.message || error).toLowerCase();
                const isQrCodeError =
                    error.message === 'qr_code_text must be unique' ||
                    errorString.includes('qr_code_text') ||
                    errorString.includes('qr code') ||
                    (errorString.includes('unique') && errorString.includes('qr'));

                if (isQrCodeError) {
                    toastManager.forceError('qr_code must be unique');
                } else {
                    if (errorString.includes('5xx') || errorString.includes('server error') || errorString.includes('internal')) {
                        notify('Server error occurred. Please try again later or contact support.');
                    } else {
                        notify('Failed to update project');
                    }
                }
            }
        }
        if (questions?.length === 0) {
            alert('No questions have been uploaded. Please upload questions before proceeding.');
        } else if (startMessage === '' || endMessage === '') {
            alert('Please add a start and end message before proceeding.');
        }
        else {
            navigate('/projects');
        }
    }

    const handleClickNextStep0 = async () => {
        // Validate required fields
        if (!qrCodeText || qrCodeText.trim() === '') {
            notify('QR Code text is required');
            setQrCodeError('QR Code text is required');
            return;
        }

        // Check QR code uniqueness only if it has changed
        if (qrCodeText !== initialQrCodeText) {
            try {
                const result = await ProjectRepository.checkQrCodeUniqueness(qrCodeText, cleanedProjectId);

                if (result && result.isUnique === false) {
                    notify('QR code text already exists. Please use a different text.');
                    setQrCodeError('QR code text already exists. Please use a different text.');
                    return;
                }
            } catch (error) {
                console.error('Error checking QR code uniqueness:', error);
                notify('Error validating QR code text. Please try again.');
                return;
            }
        }

        // Clear any previous errors
        setQrCodeError('');

        // Proceed to next step
        stepChanges(0, 1);
    };

    const saveDescription = async () => {
        if (desc !== '' && desc !== initialDesc) {
            try {
                await ProjectRepository.updateProject({ description: desc }, cleanedProjectId);
                setDesc(desc);
                setinitialDesc(desc);
            } catch (error) {
                console.error('Failed to update description:', error);
                notify('Failed to update description');
                setDesc(initialDesc);
            }
        } else {
            notify('Description cannot be empty');
            setDesc(initialDesc);
        }
    };

    const handleDownload = (data) => {
        const ws = XLSX.utils.json_to_sheet(data.map(item => ({
            'Name': item.name,
            'Phone Number': item.phone_no,
            'Is Field Officer': item.is_field_officer ? 'Yes' : 'No',
            'Project ID': item.project_id
        })));

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Contacts");

        // Create file name with current date
        const date = new Date();
        const fileName = `Contacts_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.xlsx`;

        // Write the Excel file
        XLSX.writeFile(wb, fileName);
    };

    const removeContactsById = (id) => {
        setContacts(contacts.filter(contact => contact.sourceFileId !== id));
        setuserFiles(userFiles.filter(file => file.id !== id));
    };

    const handleFileChange = (e) => {
        if (!e.target.files[0]) {
            notify('No file chosen. Please choose a file.');
            return;
        }
        const file = e.target.files[0];
        setFile(file);
        const reader = new FileReader();
        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: 'binary' });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

            if (
                data?.length > 0 &&
                data[0]?.length >= 3 &&
                data[0][0]?.toLowerCase() === 'questions' &&
                data[0][1]?.toLowerCase() === 'questionstype' &&
                data[0][2]?.toLowerCase() === 'choices'
            ) {
                setError(null);
                const filteredData = data.slice(1).filter(row => (String(row?.[0] ?? '').trim() && String(row?.[1] ?? '').trim()));

                if (!filteredData.length) {
                    notify('The uploaded file contains only headers with no question data. Please add at least one question and re-upload.');
                    setFile(null);
                    return;
                }

                if (filteredData?.length > max_questions) {
                    notify(`More than ${max_questions} questions detected. Only the first ${max_questions} will be processed.`);
                }

                // Validate all Multiple Choice questions BEFORE processing
                const limitedData = filteredData.slice(0, max_questions);

                for (let i = 0; i < limitedData.length; i++) {
                    const row = limitedData[i];
                    const questionType = row[1];
                    const questionText = row[0];

                    // Validate only for Multiple Choice questions
                    if (questionType === 'Multiple Choice') {
                        const options = row[2] ? row[2].split(';') : [];

                        // Check if number of options exceeds 10
                        if (options.length > 10) {
                            notify(`Upload rejected: Question "${questionText}" contains ${options.length} options. Maximum allowed is 10 options per Multiple Choice question.`);
                            setError(`Upload rejected: Question "${questionText}" has ${options.length} options. Maximum 10 allowed.`);
                            return; // Stop processing and reject the entire upload
                        }

                        // Check if any option exceeds 15 characters
                        for (let j = 0; j < options.length; j++) {
                            const option = options[j];
                            if (option && option.length > 15) {
                                notify(`Upload rejected: Question "${questionText}" has an option "${option}" with ${option.length} characters. Maximum 15 characters allowed per option.`);
                                setError(`Upload rejected: Option "${option}" exceeds 15 characters (${option.length} chars).`);
                                return; // Stop processing and reject the entire upload
                            }
                        }
                    }
                }

                const newQuestions = limitedData.map(row => {
                    const [q_text, q_type, optionsString] = row;
                    let modifiedQText = q_text;
                    if (q_type === 'Location') {
                        modifiedQText += "📍";
                    }
                    const question = {
                        q_id: uuidv4(),
                        q_text: modifiedQText,
                        q_type: q_type
                    };
                    if (q_type === 'Multiple Choice' && optionsString) {
                        question.options = optionsString.split(';');
                    }
                    return question;
                });

                setQuestions(newQuestions);
            } else {
                notify("The first three cells must be named 'questions', 'questionstype', and 'choices'.");
            }
        };
        reader.readAsBinaryString(file);
        e.target.value = null;
    }

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const items = Array.from(questions);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setQuestions(items);
    };

    const deleteQuestion = (id) => {
        setQuestions(questions.filter(question => question.q_id !== id));
    };


    if (isLoading) {
        return <div className='textcolor'>Loading...</div>; // Show loading state until questions are ready
    }


    return (
        <>
            {isPageLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                    <CSpinner className='spinner' />
                </div>
            ) : (<div>
                <CCard className='ccard ccard'>
                    <CCardHeader className='view-data-header'>
                        <div >
                            {name}
                        </div>
                    </CCardHeader>
                    <CCardBody>
                        {/* <div style={{ fontSize: '20px' }}>
                        {desc}
                    </div> */}
                        <div className='flexStart' style={{ fontSize: '20px' }}>
                            <textarea
                                ref={textAreaRef}
                                value={desc}
                                onChange={(e) => setDesc(e.target.value)}
                                className='descInput'
                                placeholder="Enter description here..."
                                style={{ minWidth: '20%', width: '90%', marginBottom: '2rem', maxHeight: '10rem', resize: 'none' }}
                            />
                            {/* Hidden span to measure text width */}
                            <span ref={spanRef} style={{ position: 'absolute', visibility: 'hidden', height: 'auto', width: 'auto', whiteSpace: 'nowrap', fontSize: '20px' }}>
                                {desc}
                            </span>
                            {desc !== initialDesc && (
                                <CIcon onClick={saveDescription} icon={cilSave} size="xl" style={{ cursor: "pointer" }} />
                            )}
                        </div>
                        {/* {error && <p className="error-message">{error}</p>} */}
                        <div className="container">
                            <ul className="progressbar">
                                <li onClick={() => { stepChanges(step, 0) }} className={`card-header-step step ${step >= 0 ? 'active' : ''}`}>
                                    <div className='mainNavDiv'>
                                        <img style={{ width: '2rem' }} src={messages} />
                                        {/* <div className='numDiv'>
                                        📧questions
                                    </div> */}
                                        <div className="flexCenter">
                                            Configure Messages
                                        </div>
                                    </div>
                                </li>
                                <li onClick={() => { stepChanges(step, 1) }} className={`card-header-step step ${step >= 1 ? 'active' : ''}`}>
                                    <div className='mainNavDiv'>
                                        <img style={{ width: '2rem' }} src={questionsIcon} />
                                        {/* <div className='numDiv'>
                                        📝
                                    </div> */}
                                        <div>
                                            Upload Questions
                                        </div>
                                    </div>
                                </li>
                                {/* <li onClick={() => { stepChanges(step, 2) }} className={`card-header-step step ${step >= 2 ? 'active' : ''}`}>
                                <div className='mainNavDiv'>
                                    <div className='numDiv'>
                                        👤
                                    </div>
                                    <div>
                                        Upload Users
                                    </div>
                                </div>
                            </li> */}
                                <li onClick={() => { stepChanges(step, 3) }} className={`card-header-step step ${step >= 3 ? 'active' : ''}`}>
                                    <div className='mainNavDiv'>
                                        <img style={{ width: '2rem' }} src={languageIcon} />
                                        {/* <div className='numDiv'>
                                        🌐languageIcon
                                    </div> */}
                                        <div>
                                            Select Language
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </CCardBody>
                </CCard>
                {step == 0 && <>
                    <CCard className="custom-card ccard">
                        <CCardBody>
                            <CAccordion>
                                <CAccordionItem itemKey={1}>
                                    <CAccordionHeader >Quick Guide for adding configuration message</CAccordionHeader>
                                    <CAccordionBody style={{ marginLeft: '2rem' }}>
                                        <ol className="guide-list">
                                            <li>
                                                <strong>Add Initial Greeting Message</strong> - Enter the initial greeting message that you want users to see when they first start a conversation on WhatsApp.
                                            </li>
                                            <li>
                                                <strong>Add Closure Message</strong> - Enter the closure message that users will recieve once they answer all the questions on Whatsapp.
                                            </li>
                                            <li>
                                                <strong>Add QR Code Text</strong> - Enter the QR Code Text that users will recieve once they scan the QR code on Whatsapp.
                                            </li>
                                            <li>
                                                <strong>Save Your Changes</strong> - After configuring the initial greeting message and closure message, click the "Next" button to apply your changes.
                                            </li>
                                        </ol>
                                    </CAccordionBody>
                                </CAccordionItem>
                            </CAccordion>
                        </CCardBody>
                    </CCard>

                    <CCard className="custom-card ccard">
                        <CCardHeader className='greeting-sec-header'>
                            Customize Your Greeting and Closure Messages
                        </CCardHeader>
                        <CCardBody>
                            <div className="mb-3">
                                <h6>*Greeting Message:</h6>
                                <textarea placeholder='Eg: Welcome! We appreciate your participation in this survey. Your insights will help us improve our services.' value={startMessage} onChange={(e) => setStartMessage(e.target.value)} className="form-control" rows="2" disabled={!messagesEditable}></textarea>
                            </div>
                            <div className="mb-3">
                                <h6>*Closure Message:</h6>
                                <textarea placeholder='Eg: Thank you for completing our survey! Your feedback is crucial to our efforts to improve.' value={endMessage} onChange={(e) => setEndMessage(e.target.value)} className="form-control" rows="2" disabled={!messagesEditable}></textarea>
                            </div>
                            <div className="mb-3">
                                <h6>*QR Code Text:</h6>
                                {qrCodeError && <p className="text-danger">{qrCodeError}</p>}
                                <textarea placeholder='Eg: Thank you for joining our survey. Press enter to proceed. By participating, you consent to our terms and privacy policy.' value={qrCodeText} onChange={(e) => setQrCodeText(e.target.value)} className="form-control" rows="2" disabled={!messagesEditable}></textarea>
                            </div>
                        </CCardBody>
                    </CCard>
                    <CButton onClick={handleClickNextStep0} style={{ marginTop: '1rem', marginBottom: '14px' }} className="custom-file-input">
                        Next
                    </CButton>
                </>}
                {step === 1 && (
                    isEditable ? (
                        <Step1
                            nextStep={nextStep}
                            questions={questions}
                            onFileChange={handleFileChange}
                            onDragEnd={handleDragEnd}
                            onDeleteQuestion={deleteQuestion}
                            file={file}
                            projectId={cleanedProjectId}
                            stepChanges={stepChanges}
                        />
                    ) : (
                        <Step1Static
                            nextStep={nextStep}
                            questions={questions}
                            file={file}
                            projectId={cleanedProjectId}
                            stepChanges={stepChanges}
                            noteVisible={true}
                        />
                    )
                )}
                {/* {step === 2 && <Step2 nextStep={nextStep} prevStep={prevStep} onFileChange={handleUserFileChange} contacts={contacts} contactsFile={contactsFile} onDeleteContact={deleteContact} projectId={cleanedProjectId} stepChanges={stepChanges} userFiles={userFiles} removeContactsById={removeContactsById} handleDownload={handleDownload} />} */}
                {step === 3 && <Step3 selectedLanguages={selectedLanguages} setSelectedLanguages={setSelectedLanguages} prevStep={prevStep} projectId={cleanedProjectId} saveChangesNavigate={saveChangesNavigate} stepChanges={stepChanges} initialLanguages={initialLanguages} />}
            </div >)}
        </>
    );
};

export default WizardComponent;